import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const ToxicologyTestingTypes = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem py-md-5 py-4 bg-img' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/12/ULC-Testing-bg-v1.png")', height:'100%', width:'100%'}}>
            <div className='py-2'>
                <text className='fs-ss-30-2 text-montserrat text-ss-primary fw-700'>
                    Types of Toxicology Testing
                </text>  
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-4 pb-md-4'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black'>
                    Diverse types of toxicology testing are used to evaluate the safety and efficacy of a substance. Some of these methods include:
                </text>  
            </div>

            <div className='py-2'>
                <text className='fs-ss-22 text-montserrat fw-700 text-ss-secondary'>
                    1) In Vitro Testing
                </text>  
            </div>

            <div className='pb-4 pb-md-4'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black'>
                    In vitro, testing involves using cell cultures and tissues to evaluate the effects of a substance. This method is less expensive and more efficient than animal testing. In vitro, testing helps identify potential toxicological hazards and can be used in the initial stages of drug development.
                </text>  
            </div>

            <div className='py-2'>
                <text className='fs-ss-22 text-montserrat fw-700 text-ss-secondary'>
                    2) In Vivo Testing
                </text>  
            </div>

            <div className='pb-md-4  pb-4'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black'>
                    In vivo, testing involves using animals to evaluate the effects of a substance. This method is used to determine the potential toxicological effects of a substance on the whole organism. In vivo, testing is more accurate than in vitro testing but is more expensive and time-consuming.
                </text>  
            </div>

            <div className='py-2'>
                <text className='fs-ss-22 text-montserrat fw-700 text-ss-secondary'>
                    3) Clinical Trials
                </text>  
            </div>

            <div className='pb-4'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black'>
                    Clinical trials involve using humans to evaluate the safety and effectiveness of a drug. Furthermore, this testing is conducted after in vitro and in vivo testing. Clinical trials are the final stage of drug development before approval.
                </text>  
            </div>

            <div className='flex-center pt-3 pb-2'>
                <Button className='btn-ss-secondary rounded30 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                    <Link to='/toxicology-test-appointment' className='text-montserrat text-white fw-600 fs-ss-18' style={{ padding:'12px 14px', textDecoration:'none'}}>
                        Schedule Your Test
                    </Link>
                </Button>
            </div>

        </div>
    </div>
  )
}

export default ToxicologyTestingTypes